export const cpscEntityFragment = `
  fragment cpscEntityFields on CpscEntity {
    entityRoleCode
    entityIdentificationCode
    entityNumber
    facility {
		id
	}
    testingInclusions {
      code
      description
    }
    testingExclusions {
      code
      description
    }
    testReports {
      reportId
      reportUrl
      accessKey
    }
  }
`;
